export const COMPONENT_CLASS = {
  CONTEXT_MENU: 'context_menu',
  MODEL_BODY: 'model_body',
  DOCUMENT_BODY_FULL_CONTENT: 'document_body_full_content',
  LAWSUIT_MOTIONS: 'pecas_processo',
} as const

export const COMPONENT_NAME = {
  JUS_IA_SELECTION_SHORTCUT: 'jus_ia_selection_shortcut',
  LAWSUIT_MOTIONS: 'pecas_processo',
  LAWSUIT_MOTIONS_MOTION: 'pecas_processo_motion',
  LAWSUIT_MOTIONS_ATTACHMENT: 'pecas_processo_attachment',
  JUSIA_SIMILAR_DOCUMENTS: 'jusia_similar_documents',
} as const

export const SELECTED_OPTION = {
  JUSIA_EXPLORE_MENU_ITEM_IN_JURIS_DOCVIEW: 'jusia_explore_menu_item_in_juris_docview',
  JUSIA_SELECTION_SHORTCUT_IN_JURIS_DOCVIEW: 'jusia_selection_shortcut_in_juris_docview',
  JUS_IA: 'jus_ia',
  LAWSUIT_ANALYSIS: 'lawsuit_analysis',
  ASK_JUS_IA: 'ask_jus_ia',
  DOWNLOAD_BUTTON: 'download_button',
  SHOW_MOTION: 'show_motion',
  JUSIA_SIMILAR_DOCUMENTS: 'jusia_similar_documents',
} as const

export const FEATURE_CLASS = {
  AI_LEGAL_SEARCH: 'ai_legal_search',
} as const

export const FEATURE_NAME = {
  SIMILAR_DOCUMENTS: 'similar_documents',
} as const
